import { Intercom } from '@mathieustan/vue-intercom';
const appId = 'jf5l8hke';
const intercom =  new Intercom({ appId });


export function openIntercom(data){
    if(intercom.isBooted){
        return;
    }
    intercom.shutdown();
    intercom.once('ready', () => {
        intercom.boot(data);
      //  intercom.show();
    });
}